var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['base_btn', _vm.font, _vm.type]},[_c('div',{staticClass:"comb left"}),_vm._v(" "),_c('div',{staticClass:"comb right"}),_vm._v(" "),_c('a',{attrs:{"href":_vm.href,"target":_vm.isNewTab ? '_blank' : ''}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }